/**
 * Product form: variant selection + AJAX add-to-cart.
 */
(function () {
  // ── Variant picker ────────────────────────────────────────────────────────
  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    let product;
    try {
      product = JSON.parse(picker.dataset.productJson);
    } catch {
      return;
    }

    const form = picker.closest('[data-product-form]');
    const idInput = form?.querySelector('[data-variant-id]');
    const selected = {};

    product.options.forEach((name, i) => {
      selected[name] = product.variants[0]?.[`option${i + 1}`];
    });

    picker.querySelectorAll('[data-option-value]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const group = btn.closest('.variant-picker__options');
        group?.querySelectorAll('[data-option-value]').forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        const label = group?.previousElementSibling?.textContent?.trim();
        if (label) selected[label] = btn.dataset.optionValue;

        const match = product.variants.find((v) =>
          product.options.every((opt, i) => v[`option${i + 1}`] === selected[opt])
        );
        if (match && idInput) idInput.value = match.id;
      });
    });
  });

  // ── AJAX Add-to-Cart ──────────────────────────────────────────────────────
  const form = document.getElementById('ProductForm');
  if (!form) return;

  // Target only the theme's ATC button, not Shopify payment buttons (Shop Pay, etc.)
  const submitBtn = form.querySelector('button[type="submit"].btn--primary');
  if (!submitBtn) return;

  const errorEl = form.querySelector('[data-form-error]');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const variantId = form.querySelector('[data-variant-id]')?.value;
    const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);

    if (!variantId) return;

    const originalText = submitBtn.textContent.trim();
    submitBtn.disabled = true;
    submitBtn.textContent = window.themeSettings?.strings?.loading || 'Adding…';
    if (errorEl) errorEl.hidden = true;

    try {
      await window.Alverio.addToCart(variantId, qty);

      // Notify header badge and any other subscribers
      window.Alverio.publish('cart:updated');

      if (window.themeSettings?.cartType === 'drawer') {
        // Open drawer and show updated cart
        window.Alverio.publish('cart:open');
        submitBtn.textContent = '✓ Added';
        setTimeout(() => {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 1500);
      } else {
        // Page cart — navigate to cart
        window.location.href = window.themeSettings?.routes?.cartUrl || '/cart';
      }
    } catch {
      if (errorEl) {
        errorEl.textContent = 'Could not add to cart. Please try again.';
        errorEl.hidden = false;
      }
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
    }
  });
})();
